export default "<div class=\"counter\">\r\n  <p class=\"number\">{{ (counter | async) || 0 }}</p>\r\n</div>\r\n";